import './theme-toggle.mjs';
import './google-analytics.mjs';
import './autocomplete.mjs';
import './tablesorter.mjs';
import './cpan.js';
import './github.js';
import './dropdown.js';
import './profile.mjs';
import './search.js';
import './bootstrap-slidepanel.js';
import './syntaxhighlighter.mjs';
import './pod2html.mjs';
import 'perl-ads';
